export default __webpack_public_path__ + "static/image3a-2931878dd8628cb10a44f35b0f6155af.gif";